import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputNumberNegativeErrorMessage = (
  <Trans>Ce champ doit être négatif</Trans>
);
